import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { concat, from, Observable } from 'rxjs'
import { Deps } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mapTo, mergeMap } from 'rxjs/operators'
import { lostPasswordActions, LostPasswordActions } from './lost-password.actions'
import { LostPasswordState } from './lost-password.reducer'
import { notification } from 'antd'
import { push } from 'connected-react-router'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { genericError } from 'src/utils/notifications.utils'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

type Actions = LostPasswordActions

interface Action$ extends ActionsObservable<Actions> {}
interface State$ extends StateObservable<LostPasswordState> {}

const changePasswordCall = (dsService: DSService) => (p: {
  password: string
  token: string
  [startFetch]: string
}): Observable<LostPasswordActions> =>
  concat(
    from(
      dsService
        .changePassword({
          password: p.password,
          token: p.token
        })
        .map(finalizedOpt =>
          pipe(
            finalizedOpt,
            O.fold(
              () => {
                console.log(finalizedOpt)
                genericError()
                return lostPasswordActions.ChangePasswordFailure({
                  [stopFetch]: p[startFetch]
                })
              },
              _finalized => {
                console.log(_finalized)
                notification.success({
                  description: 'Votre mot de passe a bien été modifié, vous pouvez désormais vous connecter',
                  message: 'Mot de passe modifié'
                })
                return lostPasswordActions.ChangePasswordSuccess({
                  [stopFetch]: p[startFetch]
                })
              }
            )
          )
        )
    )
  )

export const changePasswordEpic = (action$: Action$, _state: State$, deps: Deps) =>
  action$.pipe(
    filter(lostPasswordActions.is.ChangePassword),
    mergeMap(changePasswordCall(deps.dsService)),
    mapTo(push('/login'))
  )

export const lostPasswordEpics = combineEpics(changePasswordEpic)



// WEBPACK FOOTER //
// ./src/users-components/lost-password/lost-password.epics.ts